import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { tenderStatus, formatTenderDeadline } from './tenderUtils';
import './TenderCollection.css';
export { isOpenTender } from './tenderUtils';

export default function TenderTable({ items = [] }) {
    return <div className="tender-grid">
        {items.map(item => {
            const fields = item.fields || {};
            const status = tenderStatus(item);
            return <article className={`tender-card tender-card--${status.tone}`} key={item.sys.id}>
                <div className="tender-card-top">
                    <span className="tender-document-icon"><DescriptionOutlinedIcon /></span>
                    <span className={`tender-status tender-status--${status.tone}`}>{status.label}</span>
                </div>
                <p className="tender-source">{fields.tenderSource || 'Procurement notice'}</p>
                <h3><Link to={`/tenderdetails/${fields.slug}`}>{fields.name}</Link></h3>
                <div className="tender-reference"><span>Reference</span><p>{fields.code || 'Not specified'}</p></div>
                <div className="tender-card-bottom">
                    <div className="tender-deadline"><span>Closing date · Timor-Leste time</span><time dateTime={fields.deadline}>{formatTenderDeadline(fields.deadline)}</time></div>
                    <Link className="tender-card-link" to={`/tenderdetails/${fields.slug}`} aria-label={`View notice: ${fields.name}`}>View notice <ArrowForwardIcon fontSize="small" /></Link>
                </div>
            </article>;
        })}
    </div>;
}
